module.exports = __webpack_public_path__ + "img/no_result.a4f0cbc5.png";